import styled from 'styled-components'
import { Box } from '../../../core-components'
import { getTextStyleCss } from '../../../core-components/text/helpers'
import { sharedInputCss, sharedInputContainerCss } from '../helpers'

type Variant = 'regular' | 'ghost' | 'nested'

const zeroWidthSpace = '​'
export const BaseTextAreaAutoExpander = styled(Box)`
  visibility: hidden;
  white-space: pre-wrap;
  word-break: break-word;

  ${getTextStyleCss('form-value-multiline')}
  // When the last line is empty, the height of the textarea is not correct, we need to add some content to fix it
  ::after {
    content: '${zeroWidthSpace}';
  }
`
export const BaseTextArea = styled(Box)<{ hasError: boolean; variant: Variant }>`
  resize: none;

  ${sharedInputCss}
  ${getTextStyleCss('form-value-multiline')}
  ::placeholder {
    ${getTextStyleCss('form-value-multiline')}
  }
`
export const BaseTextAreaWrapper = styled(Box)<{ hasError: boolean; variant: Variant }>`
  display: grid;
  overflow: hidden;
  ${sharedInputContainerCss}
`
